import { CurrentOrderMutationContextProvider } from '@reliv/redux-global-cart';
import React from 'react';
import { Container } from 'react-bootstrap';
import { IconContext } from 'react-icons/lib';
import { Provider } from 'react-redux';
import initTransferCalculator from '../init';
import AddToCartStatus from './add-to-cart-status/AddToCartStatus';
import CalculationResults from './calculation-results/CalculationResults';
import MainNavbar from './product-list/MainNavbar';
import ProductList from './product-list/ProductList';
import ShippingForm from './shipping/ShippingForm';

const App = () => {
    const store = initTransferCalculator();

    return <Provider store={store}>
        <CurrentOrderMutationContextProvider>
            <IconContext.Provider value={{ className: 'react-icons-icon' }}>
                <ShippingForm />
                <CalculationResults />
                <AddToCartStatus />
                <Container className="px-0">
                    <MainNavbar />
                    <ProductList />
                </Container>
            </IconContext.Provider>
        </CurrentOrderMutationContextProvider>
    </Provider>;
}

export default App;
